import React from "react";
import { View, Image, StyleSheet } from "@react-pdf/renderer";

const CoverPageHeader = ({ backgroundColor, logo }) => {
    const styles = StyleSheet.create({
        header: {
            backgroundColor,
            width: "100%",
            height: 90,
            position: "relative",
        },
        logo: {
            position: "absolute",
            right: 50,
            top: 25,
            ...logo?.size,
        },
    });

    return (
        <View style={styles.header}>
            {logo?.src && (
                <Image style={styles.logo} src={logo.src} />
            )}
        </View>
    );
};

export default CoverPageHeader;
